export class SlotReadyEvent {
	constructor(
		readonly variationId: string,
		readonly targetElement: HTMLElement,
		readonly slotId: Slot,
		readonly eventMergeId: string | null,
		readonly productId: string,
	) {}
}

export enum Slot {
	PARTNER_BENEFIT = "partnerBenefit",
	BOUNCE_LAYER = "bounce",
}
